module.exports = {
      id: "arrow-narrow-usage",
      viewBox: "0 0 23 53",
      url: __webpack_public_path__ + "sprite.svg#arrow-narrow-usage",
      toString: function () {
        return this.url;
      }
    }